// extracted by mini-css-extract-plugin
export default {"serviceCard":"ServiceCard_serviceCard__n4PEP","serviceCardBtn":"ServiceCard_serviceCardBtn__kJ-7E","glowing":"ServiceCard_glowing__1NGG7","motion":"ServiceCard_motion__kPoqi"};